import { settings } from './storage.js';

/* Un único estado de silencio para todas las vistas previas (cabecera de la ficha, carrusel del inicio, tarjeta ampliada de
   películas y canales): si se activa el sonido en una, las demás arrancan con sonido; si se silencia, todas en silencio.
   Por defecto, en silencio. */

export const previewMuted = () => settings.get('previewMuted') !== false;

/** Cambia el estado general y avisa a las vistas previas que estén sonando. */
export function setPreviewMuted(muted) {
    muted = !!muted;
    if (muted === previewMuted()) return;
    settings.set('previewMuted', muted);
    try { window.dispatchEvent(new CustomEvent('preview:mute', { detail: { muted } })); } catch (e) { /* sin ventana */ }
}

/** Avisa de los cambios de estado; devuelve la función que deja de avisar. */
export function onPreviewMute(fn) {
    if (typeof window === 'undefined' || !window.addEventListener) return () => {};
    const h = (e) => fn(!!(e.detail && e.detail.muted));
    window.addEventListener('preview:mute', h);
    return () => window.removeEventListener('preview:mute', h);
}
